import { Dashboard } from "@drift/oneplatfront-components";
import { WidgetsFactory } from "@drift/widget-libraries-proxy";
import React from "react";

import { useGetDashboardFromPowerboard } from "./../hooks/useGetDashboardFromPowerboard";
import ErrorAlert from "./error-alert";
import LoadingContent from "./loading-content";
import WelcomeWidget from "./welcome-widget";

const loadingHoc = (isLoading: boolean, Component: any) => {
    const LoadingHandlingComponent = (props: any) => {
        return isLoading ? <LoadingContent /> : <Component {...props} />;
    };
    return LoadingHandlingComponent;
};

const errorHoc = (error: any, Component: any) => {
    const ErrorHandlingComponent = (props: any) => {
        return error ? <ErrorAlert /> : <Component {...props} />;
    };
    return ErrorHandlingComponent;
};

const Powerboard = () => {
    const { powerboard, loading, error } = useGetDashboardFromPowerboard();

    const template = powerboard?.widgets?.map((widgetProps, index) => (
        <React.Fragment key={`${powerboard?.name ?? ""}_widget_${index}`}>
            {WidgetsFactory(widgetProps.name, {})}
        </React.Fragment>
    )) ?? [<WelcomeWidget key="generic_welcome_widget" />];

    const WrappedDashboard = errorHoc(error, loadingHoc(loading, Dashboard));

    return <WrappedDashboard title={powerboard?.name ?? "Dashboard"}>{template}</WrappedDashboard>;
};

export default Powerboard;
